import { render } from "./FormElement.vue?vue&type=template&id=99719842"
import script from "./FormElement.vue?vue&type=script&lang=js"
export * from "./FormElement.vue?vue&type=script&lang=js"

import "./FormElement.vue?vue&type=style&index=0&id=99719842&lang=css"
script.render = render

export default script